export const parseMarkup = (value: number) : string => {

    return value.toFixed(2);
};

export const stringifyMarkup = (value: number) : string => {

    return (value * 100).toFixed(2).toString();
}
